import ScrollMagic from 'scrollmagic';

export const scrollMagicSceneFactory = (
  sceneName = '',
  triggerHook,
  duration,
  controller,
  progressCallback
) => {
  const scene = new ScrollMagic.Scene({
    triggerHook,
    duration,
  })
    .addTo(controller)
    .addIndicators({ name: sceneName })
    .on('progress', () => progressCallback());

  return scene;
};
